import debug from 'debug'

import PubSub from 'pubsub-js'

import jQuery from '~/client/assets/js/common/jquery'

import handleEventStopPropagation from '~/client/assets/js/behaviour/event/stop-propagation'

import {
  normalise,
  getConfiguration,
  isRegionUS,
  isRegionEU,
  setFollowUpChange
} from '~/client/assets/js/common/render-data'

const log = debug('behaviour:menu-view')

log('`behaviour` is awake')

/**
 *  Initialise Top Level
 */
export function initialise () {
  log('initialise')

  const $ = jQuery()

  /*
   *  Get the menu item
   */
  const item = $('#menu li[data-key].active')

  /*
   *  Get the key
   */
  const key = item.data('key')

  /*
   *  Get the menu view
   */
  const view = $(`#menu-view > div[data-key=${key}]`)

  /*
   *  If the menu view has the `active` class, exit
   */
  if (view.hasClass('active')) return

  /*
   *  Otherwise ...
   */
  const {
    requestAnimationFrame = function requestAnimationFrame () {
      log('`requestAnimationFrame` is not available')
    }
  } = global

  /*
   *  This sequence ensures that the menu view is put into its expected visual state as though it has
   *  the `active` class, but before it is given the `active` class, and without animating
   *
   *  Please excuse the pyramid of doom
   *
   *  Each subsequent call must execute after its predecessor has painted, so each call requests
   *  another frame to follow it
   */
  requestAnimationFrame(() => {
    log('requestAnimationFrame')

    /*
     *  Position the view without animating by adding the `initialise` class
     */
    view
      .addClass('initialise')

    /*
     *  Request another frame. The call will execute after this paint
     */
    requestAnimationFrame(() => {
      log('requestAnimationFrame')

      /*
       *  Add the `active` class. Since the view is in its expected visual state there is nothing to animate!
       */
      view
        .addClass('active')

      /*
       *  Request another frame. The call will execute after this paint
       */
      requestAnimationFrame(() => {
        log('requestAnimationFrame')

        /*
         *  Remove the `initialise` class. The view remains in its expected visual state
         */
        view
          .removeClass('initialise')

        /*
         *  Publish the key change
         */
        PubSub.publish('key:change', key)
      })
    })
  })
}

/**
 *  Menu View (Hide)
 */
export function handleHideDelegateClick () {
  log('handleHideDelegateClick')

  const $ = jQuery()
  const key = $(this).closest('[data-key]').data('key')

  if (key) PubSub.publish('key:hide', key)
}

/**
 *  Menu View (Accordion)
 */
export function handleAccordionDelegateClick () {
  log('handleAccordionDelegateClick')

  const $ = jQuery()
  const accordion = $(this).closest('.accordion')

  accordion.siblings().removeClass('expanded')
  accordion.toggleClass('expanded')

  PubSub.publish('accordion:change')
}

export function createTooltipTextContent (v) {
  /**
   *  log('createTooltipTextContent')
   */

  const $ = jQuery()

  return $('<span />')
    .addClass('text-content')
    .text(v)
}

export function createTooltip (v) {
  /**
   *  log('createTooltip')
   */

  const $ = jQuery()

  return $('<span />')
    .addClass('tooltip mezzo')
    .append(createTooltipTextContent(v))
}

export function removeEachSiblingTooltip (n, e) {
  /**
   *  log('removeEachSiblingTooltip')
   */

  const $ = jQuery()

  const {
    clearTimeout,
    setTimeout
  } = global

  const tooltip = $(e)

  tooltip.removeClass('active')

  const timeout = tooltip.data('timeout')
  if (timeout) clearTimeout(timeout)
  tooltip.data('timeout', setTimeout(removeTooltip(tooltip), 500))
}

export function removeTooltip (tooltip) {
  /**
   *  log('removeTooltip')
   */

  return function removeTooltip () {
    tooltip.remove()
  }
}

export function renderTooltip (tooltip) {
  /**
   *  log('renderTooltip')
   */

  return function renderTooltip () {
    tooltip
      .addClass('tooltip above active')
      .removeClass('mezzo')
  }
}

export function handleMouseEnter ({ target }) {
  /**
   *  log('handleMouseEnter')
   */

  if (this === target) {
    const $ = jQuery()

    const {
      clearTimeout,
      setTimeout
    } = global

    const container = $(this)

    const title = container.attr('title') || container.data('title')
    container.removeAttr('title')
    container.data('title', title)

    container.siblings()
      .find('.tooltip')
      .each(removeEachSiblingTooltip)

    const tooltip = $(container.find('.tooltip').get(0) || createTooltip(title))

    container.append(tooltip)

    const timeout = tooltip.data('timeout')
    if (timeout) clearTimeout(timeout)
    tooltip.data('timeout', setTimeout(renderTooltip(tooltip), 250))
  }
}

export function handleMouseLeave () {
  /**
   *  log('handleMouseLeave')
   */

  const $ = jQuery()
  const container = $(this)

  const title = container.data('title') || container.attr('title')
  container.removeData('title')
  container.attr('title', title)

  container
    .find('.tooltip')
    .each(removeEachSiblingTooltip)
}

/**
 *  Renderapp (Reset)
 */
export function handleResetTopic () {
  log('handleResetTopic')

  const $ = jQuery()

  $('#menu-view > div.active')
    .removeClass('active')

  $('#menu-view > div[data-key]:not(.active)').first()
    .addClass('active')
}

/**
 *  Menu View (Key Change)
 */
export function handleKeyChangeTopic (topic, param) {
  log('handleKeyChangeTopic')

  const $ = jQuery()

  $(`#menu-view > div.active:not([data-key=${param}])`)
    .removeClass('active')

  $(`#menu-view > div[data-key=${param}]:not(.active)`)
    .addClass('active')

  PubSub.publish('menu-view:change', param)
}

/**
 *  Menu View (Key Show)
 */
export function handleKeyShowTopic (topic, param) {
  log('handleKeyShowTopic')

  const $ = jQuery()

  $(`#menu-view > div[data-key=${param}]:not(.active)`)
    .addClass('active')

  PubSub.publish('menu-view:show', param)
}

/**
 *  Menu View (Key Hide)
 */
export function handleKeyHideTopic (topic, param) {
  log('handleKeyHideTopic')

  const $ = jQuery()

  $(`#menu-view > div[data-key=${param}].active`)
    .removeClass('active')

  PubSub.publish('menu-view:hide', param)
}

/**
 *  Menu View (Media Large)
 */
export function handleMediaLargeTopic (topic, param) {
  log('handleMediaLargeTopic')

  if (param) initialise()
}

/**
 *  Menu View (Media Extra Large)
 */
export function handleMediaExtraLargeTopic (topic, param) {
  log('handleMediaExtraLargeTopic')

  if (param) initialise()
}

/**
 *  Menu View (Content Loaded - Default Export)
 */
export default function handleContentLoaded () {
  log('handleContentLoaded')

  const $ = jQuery()

  /**
   *  Menu View (Hide)
   */
  $('#menu-view > div[data-key]')
    .delegate('h3', 'click', handleHideDelegateClick)

  $('#menu-view > div[data-key]')
    .delegate('.accordion h4', 'click', handleAccordionDelegateClick)

  $('#menu-view')
    .delegate('.bloblets label', 'mouseenter', handleMouseEnter)

  $('#menu-view')
    .delegate('.bloblets label', 'mouseleave', handleMouseLeave)

  /**
   *  Renderapp (Reset)
   */
  PubSub.subscribe('renderapp:reset', handleResetTopic)

  /**
   *  Menu View (Key Change)
   */
  PubSub.subscribe('key:change', handleKeyChangeTopic)

  /**
   *  Menu View (Key Show)
   */
  PubSub.subscribe('key:show', handleKeyShowTopic)

  /**
   *  Menu View (Key Hide)
   */
  PubSub.subscribe('key:hide', handleKeyHideTopic)

  /**
   *  Menu View (Media Large)
   */
  PubSub.subscribe('media:large', handleMediaLargeTopic)

  /**
   *  Menu View (Media Extra Large)
   */
  PubSub.subscribe('media:extra-large', handleMediaExtraLargeTopic)

  /**
   *  `handleEventStopPropagation`
   */
  $('#menu-view > div[data-key]')
    .delegate('h3 span', 'click', handleEventStopPropagation)

  /**
   *  Renderapp (Change)
   *
   *    - Raise a change event
   */
  $('#renderapp')
    .trigger('change')
}
// ----------------------------
// Roll Bar / Cage Note
// ----------------------------
;(() => {
  if (
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    typeof MutationObserver === 'undefined'
  ) return

  const PANEL_SELECTOR = '#rolls_panel'
  const NOTE_ID = 'note-painted-rollbar'
  const PAINTED_CLASS = 'with-painted-roll-bar-cage'

  function updateRollbarNote () {
    const panel = document.querySelector(PANEL_SELECTOR)
    if (!panel) return

    const checked = panel.querySelector('label.selected')
    const note = document.getElementById(NOTE_ID)
    if (!note) return

    const isPainted =
      checked &&
      checked.classList.contains(PAINTED_CLASS)

    if (isPainted) {
      note.classList.remove('is-hidden')
    } else {
      note.classList.add('is-hidden')
    }
  }

  function observePanel () {
    const panel = document.querySelector(PANEL_SELECTOR)
    if (!panel) return

    const observer = new MutationObserver(updateRollbarNote)
    observer.observe(panel, { childList: true, subtree: true })

    updateRollbarNote()
  }

  const rootObserver = new MutationObserver(observePanel)
  rootObserver.observe(document.body, { childList: true, subtree: true })
})()

// ----------------------------
// US + UK: Painted body-coloured roll bar auto-mirrors body paint
// (Round 4 ref 71: "Roll bar to stay in body colour as standard")
//
// US: the roll colour list hides and the bar always takes the body colour.
// UK: the list stays (the UK price list has a free named colour for the bar)
// and the bar follows the body colour until the customer picks a colour.
//
// The mirror's change is a follow-up to the customer's change: both are one
// step of the browser history (`setFollowUpChange`), so "Back" undoes both.
// ----------------------------
const ROLL_COLOUR_FOLLOW = 'follow'
const ROLL_COLOUR_KEEP = 'keep'

/**
 *  UK: does the selected roll colour follow the body colour, or is it the customer's to keep?
 *
 *    - `roll` is the selected roll colour
 *    - `twin` is the roll colour that matches the body colour
 *    - `first` is the first roll colour in the list (the configurator selects it by itself)
 *    - `mirrored` is the roll colour the mirror selected last
 *    - `picked` is the roll colour the customer picked
 *
 *  A roll colour that is none of these came with the page (a shared link, a reload). The
 *  customer picked it before, so it is kept
 */
export function getRollColourAction ({ roll, twin, first, mirrored, picked } = {}) {
  /**
   *  log('getRollColourAction')
   */

  if (!roll) return ROLL_COLOUR_FOLLOW

  if (picked && roll === picked) return ROLL_COLOUR_KEEP

  if (roll === twin || roll === first || roll === mirrored) return ROLL_COLOUR_FOLLOW

  return ROLL_COLOUR_KEEP
}

;(() => {
  if (
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    typeof MutationObserver === 'undefined'
  ) return

  const ROLLS_SELECTOR = '#rolls_panel'
  const PAINTS_SELECTOR = '#paintcolours_panel'
  const ROLLCOLOURS_PANEL_SELECTOR = '#rollcolours_panel'
  const ROLLCOLOURS_GROUP_SELECTOR = '[data-group="rollcolours"]'
  const CAR_PANELS_SELECTOR = '#models_panel, #pack_panel'
  const RESET_SELECTOR = '#renderapp button.reset'
  const RENDERAPP_ID = 'renderapp'
  const PAINTED_FE = '+CCC'
  const BODY_PREFIX = '+BPTP'
  const ROLL_PREFIX = '+RBCP'

  // Every region except the EU. On the EU "body coloured" still shows with a
  // roll cage, so the mirror would paint EU cages body colour for free (ref 71
  // wants cages black). The EU joins once its cage rule lands.
  function isMirrorRegion () {
    try {
      return !isRegionEU()
    } catch (e) {
      return false
    }
  }

  // The US hides the roll colour list. Every other mirror region (the UK)
  // keeps it.
  function keepsRollColourList () {
    try {
      return !isRegionUS()
    } catch (e) {
      return false
    }
  }

  function showGroup (group) {
    group.style.display = ''
  }

  function hideGroup (group) {
    group.style.display = 'none'
  }

  function getSelectedFeRule (panel) {
    if (!panel) return null
    const checked = panel.querySelector('input:checked')
    const label = checked && checked.closest('label')
    return label ? (label.dataset.feRule || null) : null
  }

  function getFirstEnabledFeRule (panel) {
    if (!panel) return null
    const enabled = panel.querySelector('input:not(:disabled)')
    const label = enabled && enabled.closest('label')
    return label ? (label.dataset.feRule || null) : null
  }

  // The roll colour that matches the selected body colour
  function getTwinFeRule () {
    const bodyFe = getSelectedFeRule(document.querySelector(PAINTS_SELECTOR))
    if (!bodyFe || !bodyFe.startsWith(BODY_PREFIX)) return null
    return ROLL_PREFIX + bodyFe.slice(BODY_PREFIX.length)
  }

  // UK only. `picked` is the roll colour the customer picked (theirs to keep),
  // `mirrored` the roll colour the mirror selected last. `isMirrorClick` marks
  // the mirror's own click, so it is not taken for the customer's.
  // `isHistoryStep`: the page shows a step of the browser history again.
  let picked = null
  let mirrored = null
  let isMirrorClick = false
  let isHistoryStep = false

  // Renderapp writes a step of the browser history after it has told
  // `#renderapp` about the change. So the step holds the configuration on the
  // page only when the page went to that step ("Back", "Forward", a reload).
  function getIsHistoryStep () {
    try {
      const { state } = window.history
      const configuration = state ? state.configuration : null

      return !!configuration && normalise(configuration) === normalise(getConfiguration())
    } catch (e) {
      return false
    }
  }

  // Renderapp's own updates (defaults, Reset, the Back button) set `checked`
  // without a `change` event, so a `change` on a roll colour is the customer's.
  function handleChange ({ target }) {
    if (!target || typeof target.closest !== 'function') return

    // Renderapp has applied a configuration (every change ends with this event)
    if (target.id === RENDERAPP_ID) {
      isHistoryStep = getIsHistoryStep()
      return
    }

    // Another model or pack: renderapp starts that car from its defaults
    if (target.closest(CAR_PANELS_SELECTOR)) {
      picked = null
      return
    }

    if (isMirrorClick || !target.checked) return

    const label = target.closest(`${ROLLCOLOURS_PANEL_SELECTOR} label`)
    if (!label) return

    // Picking the body colour itself hands the bar back to the mirror
    const rollFe = label.dataset.feRule || null
    picked = rollFe === getTwinFeRule() ? null : rollFe
  }

  function handleClick ({ target }) {
    if (!target || typeof target.closest !== 'function') return

    if (target.closest(RESET_SELECTOR)) picked = null
  }

  // When switching back to body-coloured, the matching swatch can be
  // momentarily missing/disabled because the picker is mid-rebuild — the
  // observer's old class-only filter could miss the frame it re-enables on,
  // leaving the previous roll colour stuck. Retry across a few frames so the
  // mirror self-heals before falling back to the manual picker.
  const RETRY_FRAMES = 12
  let retriesLeft = RETRY_FRAMES

  function syncRollcolourFromBody (isRetry) {
    if (!isMirrorRegion()) return

    const rolls = document.querySelector(ROLLS_SELECTOR)
    const rollcoloursGroup = document.querySelector(ROLLCOLOURS_GROUP_SELECTOR)
    if (!rolls || !rollcoloursGroup) return

    const isPaintedBodyColoured = getSelectedFeRule(rolls) === PAINTED_FE

    if (!isPaintedBodyColoured) {
      showGroup(rollcoloursGroup)
      return
    }

    const targetRollFe = getTwinFeRule()
    if (!targetRollFe) {
      showGroup(rollcoloursGroup)
      return
    }

    const rollcoloursPanel = document.querySelector(ROLLCOLOURS_PANEL_SELECTOR)

    const keepsList = keepsRollColourList()
    if (keepsList) {
      showGroup(rollcoloursGroup)

      const rollFe = getSelectedFeRule(rollcoloursPanel)

      // "Back" / "Forward": the step shows again as the customer left it, so a
      // roll colour that isn't the body colour is the customer's
      if (isHistoryStep) {
        picked = rollFe !== targetRollFe ? rollFe : null
        mirrored = null
      }

      // The customer's colour is gone (another finish or another car dropped it)
      if (picked && picked !== rollFe) picked = null

      const action = getRollColourAction({
        roll: rollFe,
        twin: targetRollFe,
        first: getFirstEnabledFeRule(rollcoloursPanel),
        mirrored,
        picked
      })

      if (action === ROLL_COLOUR_KEEP) return
    }

    const targetLabel = rollcoloursPanel
      ? rollcoloursPanel.querySelector(`label[data-fe-rule="${targetRollFe}"]`)
      : null

    const targetInput = targetLabel ? targetLabel.querySelector('input') : null
    if (!targetLabel || !targetInput || targetInput.disabled) {
      // Target not selectable *yet*: retry on the next frames (a fresh, non-retry
      // call resets the budget) before falling back to the manual picker — the
      // genuine no-match case (e.g. +RBCPCBL is UK/EU-only on a US trim).
      if (!isRetry) retriesLeft = RETRY_FRAMES
      if (retriesLeft > 0 && typeof requestAnimationFrame === 'function') {
        retriesLeft--
        requestAnimationFrame(() => syncRollcolourFromBody(true))
        return
      }
      showGroup(rollcoloursGroup)
      return
    }

    retriesLeft = RETRY_FRAMES
    if (!keepsList) hideGroup(rollcoloursGroup)
    if (!targetInput.checked) {
      isMirrorClick = true
      setFollowUpChange(true)
      try {
        targetLabel.click()
      } finally {
        setFollowUpChange(false)
        isMirrorClick = false
      }
    }
    mirrored = targetRollFe
  }

  let panelObserver = null
  let observedRolls = null
  let observedPaints = null
  let observedRollcolours = null
  function attachObserver () {
    const rolls = document.querySelector(ROLLS_SELECTOR)
    const paints = document.querySelector(PAINTS_SELECTOR)
    const rollcoloursPanel = document.querySelector(ROLLCOLOURS_PANEL_SELECTOR)
    if (!rolls || !paints || !rollcoloursPanel) return

    // Already observing these exact nodes — nothing to do. If a panel was
    // replaced in the DOM (rebuild), the existing observer is bound to detached
    // nodes and would never fire again, so rebind to the live ones.
    if (
      panelObserver &&
      observedRolls === rolls &&
      observedPaints === paints &&
      observedRollcolours === rollcoloursPanel
    ) return

    if (panelObserver) panelObserver.disconnect()
    panelObserver = new MutationObserver(() => syncRollcolourFromBody())
    const opts = { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'disabled', 'checked'] }
    panelObserver.observe(rolls, opts)
    panelObserver.observe(paints, opts)
    panelObserver.observe(rollcoloursPanel, opts)
    observedRolls = rolls
    observedPaints = paints
    observedRollcolours = rollcoloursPanel

    syncRollcolourFromBody()
  }

  document.addEventListener('change', handleChange, true)
  document.addEventListener('click', handleClick, true)

  const rootObserver = new MutationObserver(attachObserver)
  rootObserver.observe(document.body, { childList: true, subtree: true })
  attachObserver()
})()
